import React from 'react';
import moment from 'moment';
import global from '../../../../common/utility/global';
import { FORMAT_2DECIMALS, GREATER_THAN_ZERO } from '../../../../common/types/regularExpresionType';
import { Table, Empty, Button, Input, Form, Select, DatePicker, Icon } from 'antd';
const { Option } = Select;

export default function FormaPago(props) {
    return (
        <div>
            <Table
                style={{ overflowX: 'auto' }}
                className={'table-cuota'}
                size="small"
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.identifier}
                locale={{
                    emptyText: <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description='Pulse el botón "+ Agregar".'
                    />
                }}
                columns={[
                    {
                        key: 'remove-button',
                        align: 'center',
                        width: '50px',
                        render: (value, row) => (
                            <span>

                                <div className="custom-options">

                                    {props.onGetFieldDecorator(`arrMetodoPagoCredito[${row.identifier}]`, {
                                        rules: [{
                                            required: false,
                                        }]
                                    })(
                                        <Button
                                            type="danger"
                                            icon="delete"
                                            size={"small"}
                                            onClick={() => props.onRemove(value)}
                                        />
                                    )}

                                </div>

                            </span>
                        )
                    },
                    {
                        title: 'Fecha Pago',
                        dataIndex: 'fecha',
                        key: 'fecha',
                        align: 'center',
                        width: 160,
                        render: (value, row, index) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrFecha[${row.identifier}]`, {
                                        initialValue: moment(value, 'DD/MM/YYYY'),
                                        rules: [{
                                            required: true,
                                            message: "Formato (dd/mm/yyyy)"
                                        }]
                                    })(
                                        <DatePicker
                                            className="first-input"
                                            placeholder="dd/mm/yyyy"
                                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                            format="DD/MM/YYYY"
                                            onBlur={(e) => { props.onChange("Fecha", "fecha", e.target.value, row.identifier, index); }}

                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },



                    {
                        title: 'Método de Pago',
                        dataIndex: 'idMetodoPago',
                        key: 'idMetodoPago',
                        width: 160,
                        render: (value, row, index) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrMetodoPago[${row.identifier}]`, {
                                        initialValue: value ? { key: value } : undefined,
                                        validateTrigger: ['onBlur'],
                                        rules: [{
                                            required: true,
                                            message: 'Requerido'
                                        }]
                                    })(
                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione Tipo Pago"}
                                            optionFilterProp="children"
                                            onChange={(option) => { props.onChange(option.label, "idMetodoPago", option.key, row.identifier, index); }}
                                        >
                                            {props.listaMetodoPago.map((item) => (
                                                ["NOTA", "FACTURA"].includes(item.nombre.split(" ")[0].toUpperCase()) ?
                                                    (
                                                        <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                                    ) : null

                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            );
                        }
                    },






                    {
                        title: 'Nro Documento',
                        dataIndex: 'nroDocumento',
                        key: 'nroDocumento',
                        //className:'hide',
                        width: 160,
                        render: (value, row, index) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrDocumento[${row.identifier}]`, {
                                        initialValue: value,
                                        validateTrigger: ['onBlur'],
                                        rules: [{
                                            required: true,
                                            message: 'Requerido',
                                            whitespace: true
                                        }]
                                    })(
                                        <Input
                                            placeholder="Ingresar Documento"
                                            autoComplete="off"
                                            disabled={false}
                                            onBlur={(e) => { props.onChange("Documento", "arrDocumento", e.target.value, row.identifier); }}

                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },

                    {
                        title: 'Moneda',
                        dataIndex: 'idMoneda',
                        key: 'idMoneda',
                        width: 160,
                        render: (value, row, index) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrMoneda[${row.identifier}]`, {
                                        initialValue: value ? { key: value } : undefined,
                                        validateTrigger: ['onBlur'],
                                        rules: [{
                                            required: true,
                                            message: 'Requerido'
                                        }]
                                    })(
                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione Moneda"}
                                            optionFilterProp="children"
                                            disabled={props.dataSource.length == 2 ? true : false}
                                            onChange={(option) => { props.onChange(option.label, "idMoneda", option.key, row.identifier, index); }}

                                        >
                                            {props.listaMoneda.map(item => (
                                                <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            );
                        }
                    },

                    {
                        title: 'Monto a Pagar',
                        dataIndex: 'montoCuota',
                        key: 'montoCuota',
                        width: 160,
                        render: (value, row, index) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrMontoCuota[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_2DECIMALS),
                                            message: "Formato (0.00)"
                                        },
                                        {
                                            required: true,
                                            pattern: new RegExp(GREATER_THAN_ZERO),
                                            message: "Monto de Cuota debe ser mayor a 0"
                                        }]
                                    })(
                                        <Input
                                            className="text-right"
                                            onKeyPress={global.onKeyPressDecimals}
                                            placeholder="Ingresar Monto de Cuota"
                                            autoComplete="off"
                                            onBlur={(e) => { props.onChange("Monto", "arrMontoCuota", e.target.value, row.identifier); }}

                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    }

                ]}
            />
        </div>
    );
}